module.exports = __webpack_public_path__ + "static/grandwizzard-poster-d6c6b42c330af34325ddb0305597c76f.jpg";